import { getProperty } from '../utils';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case 'ARTICLE_FETCHED':
    case 'GIFT_GUIDE_FETCHED':
    case 'GIFT_GUIDE_SAME_NAVIGATED':
      const pageData = action.payload.data;
      const { pageType } = pageData;

      let article = null;
      // properties that are common across various article types
      const baseArticleTracker = {
        construct: 'standard', // can be FBIA, AMP, or Standard. where do we pull this from?
        InternalExperiment1: null, // what field handles this?
        sponsorship: 'normal',
        // omitting for now:
        // device
      };

      let standardArticleTracker = {};

      // gift guide article
      if (pageType.includes('gift-guide-')) {
        const { activeArticleID } = pageData;
        const { lander } = pageData.data;

        standardArticleTracker = {
          author: null,
          mbCategory: 'gift-guide',
          articleType: 'gift-guide', // no contentType property in endpoint. per discussion w/ Brian, we'll use the hardcoded value of "gift-guide" for now. once the various endpoints are updated to send through an articleType value, we'll reference that and ensure that for gift guides the value is "gift-guide". also discussed difference btwn gift-guide-article-hub and gift-guide-article-section.

        };

        if (pageType === 'gift-guide-article') {
          article = pageData.data.articles.filter(article => article.id === activeArticleID)[0];
          const sponsorURL = getProperty(article, ['sponsorURL']);

          standardArticleTracker = {
            ...standardArticleTracker,
            pubDate: getProperty(lander, ['publishDate']),
            sponsorship: sponsorURL ? 'sponsored' : 'normal',
            advertiser: sponsorURL ? sponsorURL.match(/^https?\:\/\/(?:www\.)?([^\/?#]+)(?:[\/?#]|$)/i)[1].split('.')[0] : null, // discuss w/ Brian. do we want to just get the domain name of the sponsorURL (if provided)? there may not always be a sponsor URL though
            articleID: getProperty(article, ['uid']),
          };
        }

        if (pageType === 'gift-guide-lander') {
          standardArticleTracker = {
            ...standardArticleTracker,
            pubDate: getProperty(lander, ['publishDate']),
            sponsorship: 'normal',
            advertiser: null,
            articleID: getProperty(lander, ['id']),
          };
        }
      }
      // regular article
      else if (pageType.includes('article')) {
        article = pageData.article;
        standardArticleTracker = {
          author: getProperty(article, ['name']),
          mbCategory: getProperty(article, ['category']),
          pubDate: '09/01/2020',
          articleType: 'list', // this is hardcoded for now. need to discuss further w/ team and Brian
          sponsorship: 'Ally Bank', // this is hardcoded for now. the property isn't part of the endpoint response data and all articles for launch are "normal"
          advertiser: 'Ally Bank', // there is no advertiser property in the endpoint. this needs to be updated.
          articleID: getProperty(article, ['hedUrl']),
        };
      }

      return {
        ...baseArticleTracker,
        ...standardArticleTracker,
      };
      break;
    case 'LANDER_FETCHED':
    case 'SLIDESHOW_FETCHED':
    case 'CORPORATE_FETCHED':
    case 'NotFound':
      return {};
    default:
      return state;
  }
};
